<template>
  <v-card color="#4390c0">
    <div>
      <v-row justify="center" class="ma-0">
        <div class="white-card pa-2" style="border-radius: 0px">
          <v-row v-if="selectedGroup" justify="start" class="ma-0">
            <v-col cols="1">
              <v-icon @click="goBack()" color="black" class="mt-4">
                mdi-arrow-left
              </v-icon>
            </v-col>
            <v-col cols="2" md="1">
              <img
                class="profilePhoto"
                v-if="selectedGroup.image"
                :src="selectedGroup.image.url"
              />
              <v-icon v-else color="#4390c0" size="50"> mdi-account </v-icon>
            </v-col>
            <v-col cols="9" md="10">
              <h3 class="">{{ selectedGroup.name }}</h3>
              <h3 @click="showDetails = true" class="blue-color pointer">
                View Details
              </h3>
            </v-col>
          </v-row>
        </div>
      </v-row>
      <v-row justify="center" class="ma-0 mt-6 mb-16 messageBox">
        <v-row class="ma-0" justify="center">
          <h4 class="blue-color" v-if="!sortedMessages || !sortedMessages[0]">
            No messages yet...
          </h4>
        </v-row>
        <v-col
          cols="12"
          v-for="messageGroup in sortedMessages"
          :key="messageGroup.date"
          v-show="sortedMessages[0]"
        >
          <v-row justify="center" class="ma-0 mb-4">
            <h4 class="white-color">{{ messageGroup.date }}</h4>
          </v-row>
          <v-col
            cols="12"
            v-for="message in messageGroup.messages"
            :key="message.id"
            class="pa-0 mb-7"
          >
            <v-row class="ma-0 relative">
              <v-card
                rounded
                class="pa-3 message-card"
                :class="{ doctorMessage: message.userType == 'Doctor' }"
              >
                <v-row class="ma-0" justify="start">
                  <h4>{{ message.message }}</h4>
                </v-row>
                <v-row
                  v-if="message.fileName && message.fileType == 'image/png'"
                  class="ma-0"
                  justify="start"
                >
                  <img :src="message.url" class="fileImage my-2" />
                </v-row>
                <v-row v-if="message.fileName" class="ma-0" justify="start">
                  <h5 class="mt-2 fileText">{{ "-" + message.fileName }}</h5>
                </v-row>
                <v-row v-if="message.fileName" class="ma-0" justify="start">
                  <h5 class="pink-color" @click="viewFile(message.url)">
                    View File
                  </h5>
                </v-row>
                <div v-if="message.fileName && message.voiceRecording">
                  <v-row class="ma-0">
                    <v-icon
                      v-if="!isPlaying || selectedMessage != message"
                      @click="playAudio(message)"
                      size="40"
                      color="#4390c0"
                    >
                      mdi-play-circle
                    </v-icon>
                    <v-icon
                      v-if="isPlaying && selectedMessage == message"
                      @click="pauseAudio()"
                      size="40"
                      color="#4390c0"
                    >
                      mdi-pause-circle
                    </v-icon>
                    <v-icon
                      v-if="isPlaying && selectedMessage == message"
                      @click="resetAudio()"
                      size="40"
                      color="#4390c0"
                    >
                      mdi-skip-previous-circle
                    </v-icon>

                    <div class="bars mb-5 mx-3">
                      <div
                        v-for="n in 5"
                        :key="n"
                        class="bar"
                        :class="{
                          active: isPlaying && selectedMessage == message,
                        }"
                      ></div>
                    </div>
                  </v-row>
                  <!-- <v-row v-if="message.fileName" class="ma-0" justify="start">
                                        <h5 class="pink-color" @click="viewFile(message.url)">View File</h5>
                                    </v-row> -->
                </div>
                <v-row class="ma-0 mt-2 relative">
                  <img
                    v-if="message.userType == 'Doctor'"
                    src="../assets/Heart.png"
                    style="height: 25px"
                  />
                  <h5 class="mx-2" style="color: black">
                    {{ message.user || "User was removed" }}
                  </h5>
                </v-row>
              </v-card>
            </v-row>
            <v-row class="ma-0 relative">
              <h4 style="color: white">{{ message.time }}</h4>
            </v-row>
          </v-col>
        </v-col>
        <v-row
          v-if="sortedMessages && sortedMessages[0]"
          class="ma-0 mb-6"
          justify="center"
        >
          <h4 ref="targetElement" class="white-color">End of chat history</h4>
        </v-row>
      </v-row>
    </div>
    <v-dialog v-model="showDetails" v-if="selectedGroup" max-width="400">
      <v-row class="ma-0" justify="center">
        <v-card width="100%" class="groupCard pa-8">
          <v-row class="ma-0" justify="start">
            <img
              class="groupImage"
              v-if="selectedGroup.image"
              :src="selectedGroup.image.url"
            />
            <v-icon v-else color="#4390c0" size="50"> mdi-account </v-icon>
            <h2 class="mx-2 mt-2">{{ selectedGroup.name }}</h2>
          </v-row>
          <v-row class="ma-0 mt-4" justify="start">
            <h3>Group Description:</h3>
          </v-row>
          <v-row class="ma-0" justify="start">
            <p style="font-size: 18px; font-weight: 500">
              {{ selectedGroup.groupDescription }}
            </p>
          </v-row>
          <v-row class="ma-0 mt-4" justify="start">
            <h3>What does the group deal with:</h3>
          </v-row>
          <v-row class="ma-0" justify="start">
            <p style="font-size: 18px; font-weight: 500">
              {{ selectedGroup.groupPurpose }}
            </p>
          </v-row>
          <v-row class="ma-0 mt-4" justify="start">
            <h3>Group Members:</h3>
          </v-row>
          <v-col class="member-holder px-0">
            <v-row
              v-for="member in groupMembers"
              :key="member"
              class="ma-0"
              justify="start"
            >
              <v-col class="pa-0 pt-1" cols="2" md="1">
                <img
                  v-if="member.profilePhoto"
                  :src="member.profilePhoto.url"
                  style="width: 20px"
                />
                <v-icon v-else>mdi-account</v-icon>
              </v-col>
              <v-col v-if="member.firstName" class="pa-0 pt-1" cols="8" md="7">
                {{ member.firstName + " " + member.lastName }}
              </v-col>
              <v-col v-if="member.name" class="pa-0 pt-1" cols="8" md="7">
                {{ member.name + " " + member.surname }}
              </v-col>
              <v-col class="pa-0" cols="2">
                <v-btn
                  style="height: 30px"
                  dark
                  rounded
                  color="#e022d1"
                  @click="
                    selectedUser = member;
                    removingUser = true;
                  "
                  >Remove</v-btn
                >
              </v-col>
            </v-row>
            <v-row v-if="!groupMembers[0]" class="ma-0" justify="start">
              <p>No members yet...</p>
            </v-row>
          </v-col>
          <v-row class="ma-0 mt-4" justify="center">
            <v-btn
              color="#4390c0"
              dark
              depressed
              large
              style="border-radius: 24px"
              @click="showDetails = false"
            >
              Close
            </v-btn>
          </v-row>
        </v-card>
      </v-row>
    </v-dialog>
    <v-dialog v-model="removingUser" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="green"> mdi-check-circle </v-icon>
          <div class="body-1 text-h6">
            Are you sure you want to remove this user?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="removingUser = false"
          >
            CANCEL
          </v-btn>
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="removeUser()"
          >
            LEAVE
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate />
      </v-overlay>
    </v-row>
  </v-card>
</template>

<script>
import {
  collection,
  getDocs,
  where,
  getFirestore,
  getDoc,
  query,
  addDoc,
  setDoc,
  doc,
  collectionGroup,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
import { ClickOutside } from "vuetify/lib";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      selectedGroup: null,
      sortedMessages: [],
      currentMessages: [],
      showDetails: false,
      removingUser: false,
      selectedUser: null,
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      isPlaying: false,
      selectedMessage: null,
      loading: false,
    };
  },
  methods: {
    async initChat() {
      this.currentMessages = this.selectedGroup.messages;

      if (!this.currentMessages) {
        this.currentMessages = [];
        return;
      }

      this.loading = true;

      try {
        // 1. Sort messages by fullDate
        if (this.currentMessages.length) {
          this.currentMessages.sort((a, b) => {
            return (
              new Date(a.fullDate).getTime() - new Date(b.fullDate).getTime()
            );
          });

          // 2. Group messages by date
          let sortedMessages = [];

          this.currentMessages.forEach((message) => {
            let newDate = message.date;

            let existingGroup = sortedMessages.find(
              (group) => group.date === newDate
            );

            if (existingGroup) {
              existingGroup.messages.push(message);
            } else {
              sortedMessages.push({
                date: newDate,
                messages: [message],
              });
            }
          });

          this.sortedMessages = sortedMessages;
          setTimeout(() => {
            this.scrollToElement();
          }, 1000);
        }
      } finally {
        this.loading = false;
      }
    },
    scrollToElement() {
      const target = this.$refs.targetElement;
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    },
    playAudio(message) {
      this.selectedMessage = message;
      this.audio = new Audio(message.url);
      this.audio.play();
      this.isPlaying = true;
    },
    resetAudio() {
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.isPlaying = false;
      }
    },
    pauseAudio() {
      this.audio.pause();
      this.isPlaying = false;
    },
    goBack() {
      localStorage.removeItem("ViewedGroup");
      this.$emit("close");
    },
    viewFile(url) {
      window.open(url, "_blank");
    },
    async getGroup() {
      try {
        this.loading = true;
        const groupDocRef = doc(db, "groups", this.selectedGroup.id);

        this.unsubscribe = onSnapshot(groupDocRef, (docSnap) => {
          if (docSnap.exists()) {
            this.selectedGroup = docSnap.data();
            this.selectedGroup.id = docSnap.id;

            if (this.selectedGroup.messages) {
              this.selectedGroup.messages.forEach((message) => {
                let user = this.clients.find(
                  (client) => client.id == message.sender
                );
                if (user) {
                  message.user = user.firstName + " " + user.lastName;
                  message.userType = "Client";
                } else {
                  let doctorUser = this.doctors.find(
                    (doctor) => doctor.id == message.sender
                  );
                  if (doctorUser) {
                    message.user = doctorUser.name + " " + doctorUser.surname;
                    message.userType = "Doctor";
                  }
                }
              });
            }

            this.initChat();
          }
        });
        this.loading = false;
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage = "An error occured while fetching the group chat!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async removeUser() {
      this.removingUser = false;

      try {
        let userToRemove = this.selectedGroup.members.find(
          (user) => user.userID == this.selectedUser.id
        );
        let userToBlock = { ...userToRemove };
        if (!this.selectedGroup.blockedUsers) {
          this.selectedGroup.blockedUsers = [];
        }
        this.selectedGroup.blockedUsers.push(userToBlock);
        this.selectedGroup.members.splice(
          this.selectedGroup.members.indexOf(userToRemove),
          1
        );

        this.loading = true;

        const consultRef = doc(db, "groups", this.selectedGroup.id);
        await updateDoc(consultRef, {
          members: this.selectedGroup.members,
          blockedUsers: this.selectedGroup.blockedUsers,
        });
        this.loading = false;

        this.promptMessage = "Successfully removed user!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.$router.go();
        }, 3000);
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage =
          "Something went wrong while removing the user, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
  },
  props: {
    group: null,
    messages: [],
    clients: [],
    doctors: [],
  },
  async mounted() {
    this.selectedGroup = this.group;
    console.log('Group: ', this.group);
    let res = await this.getGroup();
  },
  computed: {
    groupMembers() {
      let members = [];

      this.selectedGroup.members.forEach((member) => {
        let memberExists = this.clients.find(
          (client) => client.id == member.userID
        );

        if (memberExists) {
          members.push(memberExists);
        } else {
          let memberExists = this.doctors.find(
            (doctor) => doctor.id == member.userID
          );

          if (memberExists) {
            members.push(memberExists);
          }
        }
      });

      return members;
    },
  },
};
</script>

<style scoped>
.myGroupsHolder {
  max-height: 30vh;
  overflow-y: scroll;
}

.groupCard {
  box-shadow: 1px 1px 16px lightgrey !important;
  border-radius: 15px;
}

.groupImagePreview {
  width: 100px;
  height: 100px;
}

.groupImage {
  width: 50px;
  height: 50px;
}

.textfield {
  color: white;
}

.message-box {
  background-color: grey;
  position: absolute;
  bottom: 60px;
  left: 20px;
  right: 20px;
  height: 50px;
  border-radius: 10px;
}

.join-box {
  position: absolute;
  bottom: 100px;
  left: 20px;
  right: 20px;
  height: 30px;
  border-radius: 10px;
}

.send-btn {
  width: 90%;
  height: 35px;
  border-radius: 20px;
  background-color: white;
}

.background {
  background-color: #f5f6f8;
  min-height: 80vh;
  max-height: 80vh;
}

.message-card {
  width: 60vw;
}

.ownMessageTime {
  position: absolute;
  right: 10px;
}

.messageBox {
  margin-bottom: 50px;
  max-height: 60vh;
  overflow-y: scroll;
}

.profilePhoto {
  width: 50px;
  height: 50px;
}

.message-input {
  color: white;
}

.fileText {
  word-break: break-all;
}

.fileImage {
  width: 100%;
  max-width: 500px;
}

.fileBox {
  position: absolute !important;
  bottom: 61px !important;
  background-color: #4390c0 !important;
  width: 100% !important;
  height: 45px !important;
  max-height: 45px !important;
  padding: 5px;
  border-radius: 10px;
  overflow-y: hidden;
  line-height: 32px;
}

.chat-card {
  min-height: 80px;
  max-height: 80px;
}

.bars {
  display: flex;
  align-items: flex-end;
  height: 40px;
  margin-top: 10px;
}

.bar {
  width: 6px;
  height: 10px;
  background: #4390c0;
  /* Vue green */
  margin: 0 3px;
  border-radius: 3px;
  animation: bounce 1s infinite ease-in-out;
  animation-play-state: paused;
}

/* Different delays for natural effect */
.bar:nth-child(1) {
  animation-delay: 0s;
}

.bar:nth-child(2) {
  animation-delay: 0.2s;
}

.bar:nth-child(3) {
  animation-delay: 0.4s;
}

.bar:nth-child(4) {
  animation-delay: 0.6s;
}

.bar:nth-child(5) {
  animation-delay: 0.8s;
}

/* Animate only when active */
.bar.active {
  animation-play-state: running;
}

@keyframes bounce {
  0%,
  100% {
    height: 10px;
  }

  50% {
    height: 20px;
  }
}

.member-holder {
  max-height: 300px;
  overflow-y: scroll;
}
</style>
